// credits.js – menu.c's idcredits: the text the credits screen scrolls up (M_Credits_MenuDraw), a line a row,
// a line that starts with '+' drawn in the highlighted font. Quake 2 read a `credits` file from the game
// directory first; the demo pak has none, so this is the text built in.

export const CREDITS = [
  '+QUAKE II BY ID SOFTWARE',
  '',
  '+PROGRAMMING',
  'John Carmack',
  'John Cash',
  'Brian Hook',
  '',
  '+ART',
  'Adrian Carmack',
  'Kevin Cloud',
  'Paul Steed',
  '',
  '+LEVEL DESIGN',
  'Tim Willits',
  'American McGee',
  'Christian Antkow',
  'Paul Jaquays',
  'Brandon James',
  '',
  '+BIZ',
  'Todd Hollenshead',
  'Barrett (Bear) Alexander',
  'Donna Jackson',
  '',
  '',
  '+SPECIAL THANKS',
  'Ben Donges for beta testing',
  '',
  '',
  '',
  '',
  '',
  '',
  '+ADDITIONAL SUPPORT',
  '',
  '+LINUX PORT AND CTF',
  'Dave "Zoid" Kirsch',
  '',
  '+CINEMATIC SEQUENCES',
  'Ending Cinematic by Blur Studio - ',
  'Venice, CA',
  '',
  'Environment models for Introduction',
  'Cinematic by Karl Dolgener',
  '',
  'Assistance with environment design',
  'by Cliff Iwai',
  '',
  '+SOUND EFFECTS AND MUSIC',
  'Sound Design by Soundelux Media Labs.',
  'Music Composed and Produced by',
  'Soundelux Media Labs.  Special thanks',
  'to Bill Brown, Tom Ozanich, Brian',
  'Celano, Jeff Eisner, and The Soundelux',
  'Players.',
  '',
  '"Level Music" by Sonic Mayhem',
  'www.sonicmayhem.com',
  '',
  '"Quake II Theme Song"',
  '(C) 1997 Rob Zombie. All Rights',
  'Reserved.',
  '',
  'Track 10 ("Climb") by Jer Sypult',
  '',
  'Voice of computers by',
  'Carly Staehlin-Taylor',
  '',
  '+THANKS TO ACTIVISION',
  '+IN PARTICULAR:',
  '',
  'John Tam',
  'Steve Rosenthal',
  'Marty Stratton',
  'Henk Hartong',
  '',
  'Quake II(tm) (C)1997 Id Software, Inc.',
  'All Rights Reserved.  Distributed by',
  'Activision, Inc. under license.',
  'Quake II(tm), the Id Software name,',
  'the "Q II"(tm) logo and id(tm)',
  'logo are trademarks of Id Software,',
  'Inc. Activision(R) is a registered',
  'trademark of Activision, Inc. All',
  'other trademarks and trade names are',
  'properties of their respective owners.',
];
